import React from 'react'
import { useNavigate } from 'react-router-dom'
import useSessionStore from '../store/sessionStore'
import Card from '../components/ui/Card'
import Badge from '../components/ui/Badge'
import styles from './SelectMethod.module.css'

export default function SelectMethod() {
  const navigate = useNavigate()
  const { selectedType, setSelectedMethod } = useSessionStore()

  const handleSelect = (method) => {
    setSelectedMethod(method)
    navigate('/capture')
  }

  const isVideo = selectedType === 'video'
  const title = isVideo
    ? 'How would you like to record your video?'
    : 'How would you like to capture your document?'

  const uploadBadges = isVideo
    ? ['MP4', 'MOV', 'WEBM']
    : ['JPG', 'PNG', 'HEIC', 'PDF']

  return (
    <main className={styles.main}>
      <div className={styles.container}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.sub}>Choose the method that works best for you.</p>
        <div className={styles.grid}>
          <button
            className={styles.cardButton}
            onClick={() => handleSelect('upload')}
            aria-label="Upload a file"
          >
            <Card padding="lg" className={styles.card}>
              <div className={styles.iconWrap} aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h2 className={styles.cardTitle}>Upload file</h2>
              <p className={styles.cardDesc}>
                Select a file from your device.
              </p>
              <div className={styles.badges}>
                {uploadBadges.map((b) => (
                  <Badge key={b}>{b}</Badge>
                ))}
              </div>
            </Card>
          </button>
          <button
            className={styles.cardButton}
            onClick={() => handleSelect('webcam')}
            aria-label="Use webcam"
          >
            <Card padding="lg" className={styles.card}>
              <div className={styles.iconWrap} aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M23 7l-7 5 7 5V7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <rect x="1" y="5" width="15" height="14" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
              <h2 className={styles.cardTitle}>Use webcam</h2>
              <p className={styles.cardDesc}>
                Capture directly using your laptop camera.
              </p>
              <p className={styles.note}>Camera permission will be requested.</p>
            </Card>
          </button>
        </div>
      </div>
    </main>
  )
}
